'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UrlConstructionError = exports.UnexpectedServerResponse = exports.RequestLimitExceeded = exports.MissingParamError = exports.MemoryBodyNotValidError = exports.MemoryDoesNotExistError = exports.LocationBodyNotValidError = exports.LocationDoesNotExistError = undefined;

var _MemoryServiceClient = require('./MemoryServiceClient');

var _MemoryServiceClient2 = _interopRequireDefault(_MemoryServiceClient);

var _LocationDoesNotExistError = require('./errors/LocationDoesNotExistError');

var _LocationDoesNotExistError2 = _interopRequireDefault(_LocationDoesNotExistError);

var _LocationBodyNotValidError = require('./errors/LocationBodyNotValidError');

var _LocationBodyNotValidError2 = _interopRequireDefault(_LocationBodyNotValidError);

var _MemoryDoesNotExistError = require('./errors/MemoryDoesNotExistError');

var _MemoryDoesNotExistError2 = _interopRequireDefault(_MemoryDoesNotExistError);

var _MemoryBodyNotValidError = require('./errors/MemoryBodyNotValidError');

var _MemoryBodyNotValidError2 = _interopRequireDefault(_MemoryBodyNotValidError);

var _clientLibrary = require('@seneca/client-library');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MemoryServiceClient2.default;
exports.LocationDoesNotExistError = _LocationDoesNotExistError2.default;
exports.LocationBodyNotValidError = _LocationBodyNotValidError2.default;
exports.MemoryDoesNotExistError = _MemoryDoesNotExistError2.default;
exports.MemoryBodyNotValidError = _MemoryBodyNotValidError2.default;
exports.MissingParamError = _clientLibrary.MissingParamError;
exports.RequestLimitExceeded = _clientLibrary.RequestLimitExceeded;
exports.UnexpectedServerResponse = _clientLibrary.UnexpectedServerResponse;
exports.UrlConstructionError = _clientLibrary.UrlConstructionError;